import {createEffect} from '@ngrx/effects';
import {map} from 'rxjs';
import {AppLayoutActions} from './app-layout.actions';
import {AppLayoutService} from '../../services/app-layout';
import {inject} from '@angular/core';

export const appLayoutChange = createEffect(
	(appLayoutService: AppLayoutService = inject(AppLayoutService)) => {

		return appLayoutService.layoutChange.pipe(
			map((layout) => AppLayoutActions.setAppLayout({layout}))
		);
	}, {dispatch: true, functional: true}
);
